export const Logo = ({ className = "h-9", showTag = false, light = false }) => {
  const textPrimary = light ? "#FFFFFF" : "#0A1E3F";
  const accent = light ? "#4D74FF" : "#2540FF";
  const linkPrimary = light ? "#FFFFFF" : "#0A1E3F";

  return (
    <div className="flex items-center gap-2.5" data-testid="ccc-logo">
      <svg className={`${className} w-auto`} viewBox="0 0 430 96" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="CorreCore">
        {/* interlocking chain-link mark */}
        <g fill="none" strokeWidth="12" strokeLinecap="round">
          <rect x="10" y="20" width="66" height="44" rx="22" stroke={linkPrimary} />
          <rect x="46" y="34" width="66" height="44" rx="22" stroke={accent} />
          {/* re-draw a top sliver of the first link so it reads as interlocked */}
          <path d="M76 42 a22 22 0 0 1 0 4" stroke={linkPrimary} />
        </g>
        <text x="132" y="66" fontFamily="Outfit, sans-serif" fontSize="56" fontWeight="700" letterSpacing="-1.5">
          <tspan fill={textPrimary}>Corre</tspan><tspan fill={accent}>Core</tspan>
        </text>
      </svg>
      {showTag && (
        <span className={`text-[10px] font-semibold tracking-widest uppercase px-2 py-0.5 rounded ${light ? "text-white bg-white/15" : "text-ccc-blue bg-blue-50"}`}>
          CRM
        </span>
      )}
    </div>
  );
};
